import { Routes } from '@angular/router';
import { AsmAuthority } from '@asm/components-core/models/asm-authority';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { RouterTools, solCanDeactivate } from '@sol/components';

export const routesReports: Routes = [
  // /reports → /reports/overview
  RouterTools.ofRedirect(AsmRouteId.insights_reports, AsmRouteId.insights_reports_overview),

  // /reports/overview
  RouterTools.ofLazy(
    AsmRouteId.insights_reports_overview,
    () =>
      import('@asm/components-reports/components/reports/asm-reports-overview-page/asm-reports-overview-page.component').then(
        m => m.AsmReportsOverviewPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_PLATFORM_REPORTS],
  ),

  // /reports/instances
  RouterTools.ofLazy(
    AsmRouteId.insights_reports_instances,
    () =>
      import('@asm/components-reports/components/reports/asm-report-instances-page/asm-report-instances-page.component').then(
        m => m.AsmReportInstancesPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_PLATFORM_REPORTS],
  ),

  // /reports/instances/:id
  RouterTools.ofLazy(
    AsmRouteId.insights_reports_instance_detail,
    () =>
      import('@asm/components-reports/components/reports/asm-report-detail-page/asm-report-detail-page.component').then(
        m => m.AsmReportDetailPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_PLATFORM_REPORTS],
  ),

  // /reports/templates
  RouterTools.ofLazy(
    AsmRouteId.insights_reports_templates,
    () =>
      import('@asm/components-reports/components/reports/asm-report-templates-page/asm-report-templates-page.component').then(
        m => m.AsmReportTemplatesPageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_PLATFORM_REPORTS],
  ),

  // /reports/templates/:id
  {
    ...RouterTools.ofLazy(
      AsmRouteId.insights_reports_template_detail,
      () =>
        import('@asm/components-reports/components/reports/asm-report-template-detail-page/asm-report-template-detail-page.component').then(
          m => m.AsmReportTemplateDetailPageComponent,
        ),
      [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_PLATFORM_REPORTS],
    ),
    canDeactivate: [solCanDeactivate],
  },

  // /reports/templates/:id/generate
  RouterTools.ofLazy(
    AsmRouteId.insights_reports_template_generate,
    () =>
      import('@asm/components-reports/components/reports/asm-report-generate-page/asm-report-generate-page.component').then(
        m => m.AsmReportGeneratePageComponent,
      ),
    [AsmAuthority.MODULE_EASM, AsmAuthority.VIEW_PLATFORM_REPORTS],
  ),
];
